import { render, staticRenderFns } from "./zhszBanKuai.vue?vue&type=template&id=9387dc62&scoped=true"
import script from "./zhszBanKuai.vue?vue&type=script&lang=js"
export * from "./zhszBanKuai.vue?vue&type=script&lang=js"
import style0 from "./zhszBanKuai.vue?vue&type=style&index=0&id=9387dc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9387dc62",
  null
  
)

export default component.exports